import script from "./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&lang=js"

import "./index.vue?vue&type=style&index=0&id=dac8887e&lang=scss&scoped=true"

import exportComponent from "/data/jenkins/workspace/prod-hys-h5-5.0/hys-h5-5.0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dac8887e"]])

export default __exports__